import { React, useContext } from "react";
import ThemeContext from "../context/ThemeContext";
import "./About.css";

const About = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <>
      <div className="about_container">
        <div className="profile_image">
          <img src="/assets/images/Profile.jpg" alt="profile_image" />
        </div>
        <div className={`about_content ${theme}`}>
          <h2>About</h2>

          <p>
            {`Hello! I’m Ati, a 2D animator and motion designer focused on bringing ideas to life through expressive movement and engaging visuals.
Over the years, I’ve worked with brands, studios, and creative teams on a wide range of projects, including motion graphics, character animation, stop motion, logo animation, comic motion, and story-driven content.
My path into animation wasn’t traditional. I originally studied Sports Science, which gave me a strong understanding of movement, rhythm, and body dynamics—elements that continue to influence the way I approach animation today.
What I enjoy most is finding the balance between creativity and technique, and turning simple ideas into visuals that feel alive and memorable.
Outside of animation, I enjoy reading, spending time with friends, and traveling. Discovering new cultures, stories, and places often gives me fresh inspiration for my work.`}
          </p>
          <h2>contact :</h2>
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=atefefazeli583@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            atefefazeli583@gmail.com
          </a>
        </div>
      </div>
      <hr />
      <div className="image_bottom">
        <a href="https://www.instagram.com/atefe__fazeli?igsh=eXJrbnUzbHVzd2ox" target="_blank" rel="noopener noreferrer">
          <img src="/assets/images/about.png" alt="" />
        </a>
      </div>
    </>
  );
};

export default About;
